export const BASE_URL = process.env.REACT_APP_BASE_URL;
export const PROCESS_AUTOMATION_SERVICE_URL = BASE_URL + '/process-automation-service';
export const SCTK_SERVICE_URL = BASE_URL + '/itaap-sctk/staticComplianceTesting/v1';

export const SECRETS_MANAGER_REST_API_URL = PROCESS_AUTOMATION_SERVICE_URL + '/api/v1/secret';
export const PARAMETER_STORE_MANAGER_REST_API_URL = PROCESS_AUTOMATION_SERVICE_URL + '/api/v1/parameter';
export const CACHE_MANAGER_REST_API_URL = PROCESS_AUTOMATION_SERVICE_URL + '/api/v1/cache';


